import { render } from "./AppSettingsPage.vue?vue&type=template&id=0064b20e&ts=true"
import script from "./AppSettingsPage.vue?vue&type=script&lang=ts"
export * from "./AppSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__